export const GORGIAS_INSTALL_RETURN_KEY = 'shipaid___gorgias-install-pending';
const INSTALL_PATH = '/integrations/gorgias/install';

export const canonicalGorgiasAccount = (value: unknown): string | null =>
  typeof value === 'string' && /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(value)
    ? value.toLowerCase()
    : null;

export const rememberGorgiasInstallation = (value: unknown) => {
  const account = canonicalGorgiasAccount(value);
  if (!account) throw new Error('Invalid Gorgias account.');
  localStorage.setItem(GORGIAS_INSTALL_RETURN_KEY, `${INSTALL_PATH}?account=${account}`);
};

export const getGorgiasInstallReturnPath = (): string | null => {
  const path = localStorage.getItem(GORGIAS_INSTALL_RETURN_KEY);
  if (!path) return null;
  const match = /^\/integrations\/gorgias\/install\?account=([^&?#]+)$/.exec(path);
  const account = canonicalGorgiasAccount(match?.[1]);
  if (account) return `${INSTALL_PATH}?account=${account}`;
  localStorage.removeItem(GORGIAS_INSTALL_RETURN_KEY);
  return null;
};

export const beginGorgiasAuthorization = (
  value: string,
  dependencies: { apiBaseUrl?: string; redirect?: (url: string) => void } = {},
) => {
  const apiBaseUrl = dependencies.apiBaseUrl || process.env.REACT_APP_API_BASE_URL;
  if (!apiBaseUrl) throw new Error('The ShipAid API is not configured.');
  const expected = new URL(apiBaseUrl);
  const url = new URL(value);
  if (url.protocol !== 'https:' || url.origin !== expected.origin || url.username || url.password || url.hash ||
    url.pathname !== '/v1/gorgias/oauth/install' || url.searchParams.getAll('ticket').length !== 1 ||
    url.searchParams.getAll('account').length !== 1 || !/^[a-f0-9]{64}$/.test(url.searchParams.get('ticket') || '') ||
    !canonicalGorgiasAccount(url.searchParams.get('account')) ||
    Array.from(url.searchParams.keys()).some(key => !['account', 'ticket'].includes(key))) {
    throw new Error('ShipAid did not return a valid Gorgias authorization link.');
  }
  const redirect = dependencies.redirect || ((target: string) => {
    // POST supplies a browser-controlled Origin; a copied GET URL cannot mint OAuth state.
    const form = document.createElement('form');
    form.method = 'post';
    form.action = target;
    form.target = '_self';
    document.body.appendChild(form);
    try { form.submit(); } finally { setTimeout(() => form.remove(), 0); }
  });
  redirect(url.toString());
};
